import {
  doNotProcessRequest,
  getPendoUserId,
} from 'common/services/userCookiesService';

export const apiKey = () => process.env.REACT_APP_USER_ANALYTICS_API_KEY;

const pendoStorageBase = '_pendo';
const pendoVisitorId = 'visitorId';

const anonVisitorIdKey = () =>
  `${pendoStorageBase}_${pendoVisitorId}.${undefined}`;

const getPartialKeyMatches = (searches) => (obj) =>
  Object.keys(obj).filter((key) =>
    searches.some((search) => key.includes(search))
  );

export const cookies = () =>
  document.cookie
    .split(';')
    .map((cookie) => cookie.split('='))
    .filter((keyValue) => keyValue.length === 2)
    .map(([key, value]) => [key.trim(), value.trim()])
    .reduce((obj, [key, value]) => ({ ...obj, [key]: value }), {});

const deleteCookies = (storageKeys = []) => {
  storageKeys.forEach((cookie) => {
    document.cookie = `${cookie}=;expires=Thu, 01 Jan 1970 00:00:00 GMT`;
  });
};

const deleteCookieWherePartialMatch = (searches) => {
  const keys = getPartialKeyMatches(searches)(cookies());
  deleteCookies(keys);
};

const deleteLocalStorage = (storageKeys = []) => {
  storageKeys.forEach((key) => localStorage.removeItem(key));
};

const deleteLocalStorageWherePartialMatch = (searches) => {
  const keys = getPartialKeyMatches(searches)(localStorage);
  deleteLocalStorage(keys);
};

const accessStorage = (storageKey) => {
  const value = localStorage.getItem(storageKey) || cookies()[storageKey];
  if (value) {
    try {
      return JSON.parse(value).value;
    } catch (e) {
      return value;
    }
  }
  return undefined;
};

const getPerformanceCookiesTableCellValues = (policy = '') => {
  const [, table = ''] = policy.split('performance-cookies-table');
  const tableWithoutNewlines = table.replace(/\r\n/g, '');
  const tableCells = tableWithoutNewlines.match(/<td>.*?<\/td>/g) || [];
  return tableCells.map((tv) => tv.replace(/<td>|<\/td>/g, ''));
};

const anonVisitorId = () => accessStorage(anonVisitorIdKey());

export const removeFromStorage = (policy) => {
  const tableCellValues = getPerformanceCookiesTableCellValues(policy);
  deleteLocalStorageWherePartialMatch(tableCellValues);
  deleteCookieWherePartialMatch(tableCellValues);
};

export const toggleTableClass = (checked) => {
  const table = document.getElementById('performance-cookies-table');
  if (table) {
    if (checked) {
      table.classList.remove('disabled');
    } else {
      table.classList.add('disabled');
    }
  }
};

export const getDoNotProcessRequest = (allowProcessing) => {
  return [
    doNotProcessRequest('visitor', getPendoUserId(), allowProcessing),
    doNotProcessRequest('visitor', anonVisitorId(), allowProcessing),
  ].filter((x) => x);
};
